// Feriados fijos de Perú
const feriadosFijos = [
  { mes: 1, dia: 1 }, // Año Nuevo
  { mes: 5, dia: 1 }, // Día del Trabajo
  { mes: 7, dia: 28 }, // Independencia
  { mes: 7, dia: 29 }, // Independencia
  { mes: 8, dia: 30 }, // Santa Rosa de Lima
  { mes: 10, dia: 8 }, // Combate de Angamos
  { mes: 11, dia: 1 }, // Todos los Santos
  { mes: 12, dia: 8 }, // Inmaculada Concepción
  { mes: 12, dia: 9 }, // Batalla de Ayacucho
  { mes: 12, dia: 25 } // Navidad
  
];

// Función para calcular Viernes Santo (varía cada año)
const calcularViernesSanto = (año) => {
  // Algoritmo para calcular la fecha de Pascua
  const a = año % 19;
  const b = Math.floor(año / 100);
  const c = año % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31);
  const dia = ((h + l - 7 * m + 114) % 31) + 1;
  
  // Viernes Santo es 2 días antes de Pascua
  const pascua = new Date(año, mes - 1, dia);
  const viernesSanto = new Date(pascua);
  viernesSanto.setDate(pascua.getDate() - 2);
  
  return viernesSanto;
};

export const esFeriadoPeruano = (fecha) => {
  // ✅ SOLUCIÓN: Parsear manualmente el string
  const [year, month, day] = fecha.split('-').map(Number);
  
  // Verificar feriados fijos directamente
  const esFeriadoFijo = feriadosFijos.some(feriado => 
    feriado.mes === month && feriado.dia === day
  );
  
  if (esFeriadoFijo) return true;
  
  // Para Viernes Santo, crear fecha local
  const viernesSanto = calcularViernesSanto(year);
  const fechaLocal = new Date(year, month - 1, day);
  if (fechaLocal.toDateString() === viernesSanto.toDateString()) {
    return true;
  }
  
  return false;
};

export const obtenerNombreFeriado = (fecha) => {
  // ✅ SOLUCIÓN: Parsear manualmente
  const [year, month, day] = fecha.split('-').map(Number);
  
  const nombresFeriados = {
    '1-1': 'Año Nuevo',
    '5-1': 'Día del Trabajo',
    '7-28': 'Día de la Independencia',
    '7-29': 'Día de la Independencia',
    '8-30': 'Santa Rosa de Lima',
    '10-8': 'Combate de Angamos',
    '11-1': 'Todos los Santos',
    '12-8': 'Inmaculada Concepción',
    '12-9': 'Batalla de Ayacucho', // ✅ FALTABA ESTE
    '12-25': 'Navidad'
  };
  
  const key = `${month}-${day}`;
  if (nombresFeriados[key]) return nombresFeriados[key];
  
  // Para Viernes Santo
  const viernesSanto = calcularViernesSanto(year);
  const fechaLocal = new Date(year, month - 1, day);
  if (fechaLocal.toDateString() === viernesSanto.toDateString()) {
    return 'Viernes Santo';
  }
  
  return null;
};